import initialGlobalState, { GlobalState } from '../state/initialGlobalState';
import { getSocketIo } from './socketIo';
import userData from './userSession';

const mergedInitialState: GlobalState = {
    ...initialGlobalState,
    socket: getSocketIo(),
    userData: { ...userData, status: null }
};

export default mergedInitialState;
